import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist'
import localStorage from 'redux-persist/es/storage';
import { SharedReducer } from 'redux/reducers/SharedReducer';
import { SessionReducer } from 'redux/reducers/SessionReducer';
import { PaternityStudiesReducer } from 'redux/reducers/PaternityStudiesReducer';
import { ClientReducer } from 'redux/reducers/ClientReducer';
import { IndividualReducer } from 'redux/reducers/IndividualReducer';
import { KinshipReducer } from 'redux/reducers/KinshipReducer';
import { SampleReducer } from 'redux/reducers/SampleReducer';
import { DocumentTypeReducer } from 'redux/reducers/DocumentTypeReducer';
import { LocationReducer } from 'redux/reducers/LocationReducer';
import { GenderReducer } from 'redux/reducers/GenderReducer';
import { EthnicOriginReducer } from 'redux/reducers/EthnicOriginReducer';
import { WitnessReducer } from 'redux/reducers/WitnessReducer';
import { OfficeReducer } from 'redux/reducers/OfficeReducer';
import { TechniqueReducer } from 'redux/reducers/TechniqueReducer';
import { TranslatorReducer } from 'redux/reducers/TranslatorReducer';
import { ClinicalAnalysisTypeReducer } from 'redux/reducers/ClinicalAnalysisTypeReducer';
import { ClinicalAnalysisReducer } from 'redux/reducers/ClinicalAnalysisReducer';
import { DoctorReducer } from 'redux/reducers/DoctorReducer';
import { MedicalInstitutionReducer } from 'redux/reducers/MedicalInstitutionReducer';
import { MethodReducer } from 'redux/reducers/MethodReducer';
import { UserReducer } from 'redux/reducers/UserReducer';
import { RoleReducer } from 'redux/reducers/RoleReducer';
import { CountryReducer } from 'redux/reducers/CountryReducer';
import { SpecialtyReducer } from 'redux/reducers/SpecialtyReducer';
import { ProductReducer } from 'redux/reducers/ProductReducer';
import { PaternityStudyTypeReducer } from 'redux/reducers/PaternityStudyTypeReducer';
import { MarkerReducer } from 'redux/reducers/MarkerReducer';
import { ProspectReducer } from 'redux/reducers/ProspectReducer';
import { NurseReducer } from 'redux/reducers/NurseReducer';
import { SystemParamsReducer } from 'redux/reducers/SystemParamsReducer';
import { AppointmentSectorReducer } from './reducers/AppointmentSectorReducer';
import { CoordinationTypeReducer } from './reducers/CoordinationTypeReducer';
import { AgendaReducer } from './reducers/AgendaReducer';

// Requerimineto para auto refresh de cache
const oMeta = require('meta.json');

const reducers = combineReducers({
    SharedReducer,
    SessionReducer,
    PaternityStudiesReducer,
    ClientReducer,
    IndividualReducer,
    KinshipReducer,
    SampleReducer,
    DocumentTypeReducer,
    LocationReducer,
    GenderReducer,
    EthnicOriginReducer,
    WitnessReducer,
    OfficeReducer,
    TechniqueReducer,
    TranslatorReducer,
    ClinicalAnalysisTypeReducer,
    ClinicalAnalysisReducer,
    DoctorReducer,
    MedicalInstitutionReducer,
    MethodReducer,
    UserReducer,
    RoleReducer,
    CountryReducer,
    SpecialtyReducer,
    ProductReducer,
    PaternityStudyTypeReducer,
    MarkerReducer,
    ProspectReducer,
    NurseReducer,
    SystemParamsReducer,
    AppointmentSectorReducer,
    CoordinationTypeReducer,
    AgendaReducer,
});


const oPersistConfig = {
    key: oMeta.hash,
    version: oMeta.version,
    storage: localStorage
}

const oPersistedReducer = persistReducer(oPersistConfig, reducers)
const store = createStore(oPersistedReducer, applyMiddleware(thunk));

export default store;
export const persistor = persistStore(store);